/**
 * CRM Multi-Compagnia · Lista Incassi + registrazione rapida
 */
import { useState } from "react";
import { Banknote, Plus } from "lucide-react";
import {
  api, useApi, DataTable, Spinner, ErrorBox, Btn, Modal, Field, TextInput, Select,
  toast, fmtDateTime, fmtEUR
} from "@/components/crm-multi/shared";

const METODI = ["bonifico", "carta", "contanti", "assegno", "rid_sepa", "altro"];

export default function CrmMultiIncassiPage() {
  const list = useApi(() => api.get("/payments", { limit: 200 }));
  const clienti = useApi(() => api.get("/customers", { limit: 500 }));
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ customer_id: "", importo_eur: 0, metodo: "bonifico", data_incasso: new Date().toISOString().slice(0, 10), riferimento: "" });

  const onSave = async (e) => {
    e.preventDefault();
    try { await api.post("/payments", form); toast("Incasso registrato", "success"); setOpen(false); list.refresh(); }
    catch (er) { toast(JSON.stringify(er?.response?.data?.detail || er.message), "error"); }
  };

  const cliMap = Object.fromEntries((clienti.data?.items || []).map(c => [c.id, c.anagrafica]));

  return (
    <div className="space-y-4" data-testid="cm-incassi-page">
      <header className="flex justify-between items-center gap-3">
        <div>
          <h2 className="text-lg font-semibold flex items-center gap-2"><Banknote className="w-5 h-5" /> Incassi</h2>
          <p className="text-sm text-zinc-500">{list.data?.total ?? 0} incassi totali</p>
        </div>
        <Btn variant="primary" onClick={() => setOpen(true)} data-testid="cm-incassi-new"><Plus className="w-4 h-4" /> Registra incasso</Btn>
      </header>

      <ErrorBox error={list.error} />
      {list.loading ? <Spinner /> : (
        <DataTable
          testid="cm-incassi-table"
          columns={[
            { key: "data_incasso", label: "Data", render: r => fmtDateTime(r.data_incasso) },
            { key: "cliente", label: "Cliente", render: r => {
              const a = cliMap[r.customer_id];
              return <span className="text-xs">{a?.tipo === "azienda" ? a.ragione_sociale : `${a?.nome || ""} ${a?.cognome || ""}`}</span>;
            }},
            { key: "metodo", label: "Metodo", render: r => <span className="text-xs">{r.metodo}</span> },
            { key: "importo_eur", label: "Importo", render: r => <span className="font-mono text-sm font-semibold">{fmtEUR(r.importo_eur)}</span> },
            { key: "riferimento", label: "Riferimento", render: r => <code className="text-[10px]">{r.riferimento || "—"}</code> },
          ]}
          rows={list.data?.items || []}
          emptyTitle="Nessun incasso registrato"
        />
      )}

      <Modal open={open} onClose={() => setOpen(false)} title="Registra incasso" testid="cm-incassi-modal">
        <form onSubmit={onSave} className="space-y-3">
          <Field label="Cliente" required>
            <Select required value={form.customer_id} onChange={(e) => setForm({ ...form, customer_id: e.target.value })}>
              <option value="">Seleziona...</option>
              {(clienti.data?.items || []).map(c => <option key={c.id} value={c.id}>{c.anagrafica?.tipo === "azienda" ? c.anagrafica.ragione_sociale : `${c.anagrafica?.nome} ${c.anagrafica?.cognome}`}</option>)}
            </Select>
          </Field>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Importo €" required><TextInput required type="number" step="0.01" value={form.importo_eur} onChange={(e) => setForm({ ...form, importo_eur: parseFloat(e.target.value || 0) })} /></Field>
            <Field label="Metodo"><Select value={form.metodo} onChange={(e) => setForm({ ...form, metodo: e.target.value })}>{METODI.map(m => <option key={m}>{m}</option>)}</Select></Field>
            <Field label="Data" required><TextInput required type="date" value={form.data_incasso} onChange={(e) => setForm({ ...form, data_incasso: e.target.value })} /></Field>
            <Field label="Riferimento (CRO, etc.)"><TextInput value={form.riferimento} onChange={(e) => setForm({ ...form, riferimento: e.target.value })} /></Field>
          </div>
          <div className="flex justify-end gap-2 pt-2"><Btn variant="outline" type="button" onClick={() => setOpen(false)}>Annulla</Btn><Btn variant="primary" type="submit">Salva</Btn></div>
        </form>
      </Modal>
    </div>
  );
}
